import {Component, inject} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {ActivatedRoute, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {filter, map, startWith} from 'rxjs';
import {PublicNavComponent} from '../shared/public-nav/public-nav.component';

@Component({
  selector: 'app-public-cover-layout',
  standalone: true,
  imports: [RouterOutlet, PublicNavComponent],
  templateUrl: './public-cover-layout.component.html',
  styleUrl: './public-cover-layout.component.scss'
})
export class PublicCoverLayoutComponent {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);

  protected readonly pageTitle = toSignal(
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      startWith(null),
      map(() => {
        let route = this.activatedRoute;
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route.snapshot?.data['title'] || '';
      })
    )
  );
}
